import styled from 'styled-components';
import { ThemePrisma } from '@orbita-ui/brand';

export const VerticalDivider = styled.div`
  width: 1px;
  height: 40px;
  background: ${ThemePrisma.colors.gray[3]};
`;
